import React, {Component} from 'react';
import {Button} from 'reactstrap';
import {toast} from 'react-toastify';

import ErrorMsg from "../common/ErrorMsg";
import FormValidator from "../../validations/FormValidator";
import {ValidationRules} from "../staffDashboard/ValidationRules";
import LoadingModal from "../common/LoadingModal";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as StaffDashboardAction from "../../actions/StaffDashboardAction";
import * as AuthAction from "../../actions/AuthAction";


class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordDetail: {
                password: '',
                new_password: '',
                confirm_password: ''
            },
            errors: {},
        };
        this.validator = new FormValidator(ValidationRules);
    }

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let passwordDetail = {...this.state.passwordDetail};
        passwordDetail[name] = value;
        this.setState({passwordDetail});
    };

    saveNewPassword = async (e) => {
        e.preventDefault();
        const {passwordDetail} = this.state;
        let validationStatus = this.validator.validateForm(passwordDetail);
        if (!validationStatus.isValid) {
            this.setState((prevState) => ({
                errors: validationStatus.errors,
            }));
        } else if (passwordDetail.new_password !== passwordDetail.confirm_password) {
            let errors = {...this.state.errors};
            errors['confirm_password'] = 'New and Confirm Password Does not match.';
            this.setState((prevState) => ({errors: errors}));
        } else {
            try {
                let result = await this.props.setPassword(this.state.passwordDetail);
                if (result) {
                    toast.success("Password changed successfully.");
                    this.props.closePasswordSetting();
                }                
            } catch(error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    closePasswordDiv = async (e) => {
        e.preventDefault();
        try {
            await this.props.logOutWithoutLogging();
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        return false;
    };

    render() {
        const {passwordDetail, errors} = this.state;
                
        return (
            <section className="container-fluid pt-3">
                <div className="clearfix"></div>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <div className="card border border-info">
                            <div className="card-header bg-info text-white">
                                <h5 className="float-left mb-0">Change Password</h5>
                                <button type="button" className="close text-white opacity-1" 
                                    aria-label="Close" onClick={this.closePasswordDiv}
                                ><span aria-hidden="true">×</span></button>
                            </div>
                            <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4 text-sm-right pt-2">
                                        <label>Current Password: </label>
                                    </div>
                                    <div className="col-sm-8 mb-3">
                                        <input type="password" className="form-control" 
                                            name="password" value={passwordDetail.password} 
                                            onChange={this.handleChange} 
                                        />
                                        {errors.password && 
                                            <span className="span-error"> 
                                                {errors.password}
                                            </span> 
                                        }
                                    </div>
                                    <div className="col-sm-4 text-sm-right pt-2">
                                        <label>New Password: </label>
                                    </div>
                                    <div className="col-sm-8 mb-3">
                                        <input type="password" className="form-control" 
                                            name="new_password" 
                                            value={passwordDetail.new_password} 
                                            onChange={this.handleChange} 
                                        />
                                        {errors.new_password && 
                                            <span className="span-error"> 
                                                {errors.new_password}
                                            </span>
                                        }
                                    </div>
                                    <div className="col-sm-4 text-sm-right pt-2">
                                        <label>Confirm Password: </label>
                                    </div>
                                    <div className="col-sm-8">
                                        <input type="password" className="form-control" 
                                            name="confirm_password" 
                                            value={passwordDetail.confirm_password} 
                                            onChange={this.handleChange} 
                                        />
                                        {errors.confirm_password && 
                                            <span className="span-error"> 
                                                {errors.confirm_password}
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer text-right">
                                <Button type="submit" className='btn btn-success' 
                                    onClick={this.saveNewPassword}>Submit</Button>
                                &nbsp;&nbsp;
                                <Button type="button" className='btn btn-warning' 
                                    onClick={this.closePasswordDiv}>Cancel</Button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                {this.state.isLoading && <LoadingModal modal={this.state.isLoading} />}
            </section>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, StaffDashboardAction, AuthAction), dispatch);
};

export default connect(null, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/common/ChangePassword.js